// Frontend build stamp. `REACT_APP_BUILD_SHA` / `REACT_APP_BUILD_TIME` are
// injected at compile time by craco.config.js (git short SHA + commit ISO time),
// so this stays accurate on every build without any manual step.
export const FRONTEND_BUILD = {
  sha: process.env.REACT_APP_BUILD_SHA || 'dev',
  time: process.env.REACT_APP_BUILD_TIME || '',
};
